import _objectSpread from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { MOST_NEGATIVE_SINGLE_FLOAT, MOST_POSITIVE_SINGLE_FLOAT } from '../constants';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  gain: 1
};
export var createGainNodeConstructor = function createGainNodeConstructor(audioNodeConstructor, createAudioParam, createGainNodeRenderer, createNativeGainNode, getNativeContext, isNativeOfflineAudioContext) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(GainNode, _audioNodeConstructor);
    var _super = _createSuper(GainNode);
    function GainNode(context, options) {
      var _this;
      _classCallCheck(this, GainNode);
      var nativeContext = getNativeContext(context);
      var mergedOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
      var nativeGainNode = createNativeGainNode(nativeContext, mergedOptions);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var gainNodeRenderer = isOffline ? createGainNodeRenderer() : null;
      _this = _super.call(this, context, false, nativeGainNode, gainNodeRenderer);
      // Bug #74: Safari does not export the correct values for maxValue and minValue.
      _this._gain = createAudioParam(_assertThisInitialized(_this), isOffline, nativeGainNode.gain, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
      return _this;
    }
    _createClass(GainNode, [{
      key: "gain",
      get: function get() {
        return this._gain;
      }
    }]);
    return GainNode;
  }(audioNodeConstructor);
};